import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=2b933ecc&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=2b933ecc&prod&lang=less&scoped=true"
import style1 from "./comment.vue?vue&type=style&index=1&id=2b933ecc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b933ecc",
  null
  
)

export default component.exports